module.exports = __webpack_public_path__ + "static/media/notifications.96e2098a.svg";